
export default {
    name: 'SvgKnightTrailerDriver',
};
